<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_h5/news/block_1.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Events & News</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">Events</div>
						<div class="tit">EVENTS & NEWS</div>
					</div>
					<div class="right"></div>
				</div>
				<div v-loading="eventLoading" class="list_box">
					<div v-if="eventList.length > 0">
						<div v-for="(value, index) in eventList" :key="index" :class="value.thumb != '' ? 'block_2_el' : 'block_1_el'">
							<img v-if="value.thumb" class="img_bg" :src="weburl + value.thumb" />
							<div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);width: 90%;">
								<div class="tit">{{ value.name }}</div>
								<div class="txt">{{ value.shijian }}</div>
								<div class="txt">{{ value.address }}</div>
								<div class="txt">{{ value.booth }}</div>
								<div v-if="value.url != '' && value.url != '/'" class="btn_box">
									<van-button color="#E37542" class="btn_el" @click="goWeb(value)">LEARN MORE</van-button>
								</div>
							</div>
						</div>
						<div class="page_box">
							<el-pagination
								:small="false"
								layout="prev, pager, next"
								:total="total1"
								:page-size="3"
								:current-page="page1"
								@current-change="pageChange1"
							>
							</el-pagination>
						</div>
					</div>
					<div v-if="eventList.length == 0 && !isOnce1">
						<van-empty image="search" description="There is currently no exhibition preview available" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">News</div>
						<div class="tit">EVENTS & NEWS</div>
					</div>
					<div class="right"></div>
				</div>
				<div v-loading="articleLoading" class="news_box">
					<div v-if="newsList.length > 0">
						<div class="list_box">
							<div v-for="(value, index) in newsList" :key="index" class="list_el" @click="goInfo(value)">
								<div class="img_box">
									<van-image class="img_el" width="100%" height="220px" :src="weburl + value.image" fit="cover" />
								</div>
								<div class="tit">{{ value.title }}</div>
								<div class="txt">{{ value.description }}</div>
								<div class="time">{{ initTime(value.fabu_time) }}</div>
							</div>
						</div>
						<div class="page_box">
							<el-pagination
								:small="false"
								layout="prev, pager, next"
								:total="total2"
								:page-size="6"
								:current-page="page2"
								@current-change="pageChange2"
							>
							</el-pagination>
						</div>
					</div>
					<div v-if="newsList.length == 0 && !isOnce2">
						<van-empty image="search" description="No news information available at the moment" />
					</div>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import contact from '@/component/h5/contact.vue'  //联系我们组件
import { articleList, eventsList, articleDetail, eventsDetail } from '@/api/public.js';
import { UPURL } from '@/util/util.js';
import moment from 'moment';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			eventList: [],
			newsList: [],
			eventLoading: false,
			articleLoading: false,
			page1: 1,
			total1: 3,
			page2: 1,
			total2: 3,
			weburl: '',
			isOnce1: true,
			isOnce2: true
		}
	},
	created(){
		let that = this;
		that.weburl = UPURL;
		that.getEvents();
		that.getArticle();
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//获取展会列表
		getEvents() {
			let that = this;
			that.eventLoading = true;
			eventsList({ page: that.page1, page_size: 3 }).then(res => {
				that.total1 = res.data.total;
				that.eventList = res.data.data;
				that.isOnce1 = false;
				that.eventLoading = false;
			});
		},
		//获取文章列表
		getArticle() {
			let that = this;
			that.articleLoading = true;
			articleList({ page: that.page2, page_size: 6 }).then(res => {
				that.articleLoading = false;
				that.total2 = res.data.total;
				that.isOnce2 = false;
				that.newsList = res.data.data;
			});
		},
		//跳转详情
		goInfo(value) {
			let that = this;
			if(value.custom) {
				that.$router.push({ name: 'newsInfo', params: { newsId: value.custom } });
			}else {
				that.$toast('Parameter exception, unable to obtain detailed information.');
			}
		},
		goWeb(value) {
			window.location.href = value.url;
		},
		//分页点击
		pageChange1(val) {
			let that = this;
			that.page1 = val;
			that.getEvents();
		},
		//分页点击
		pageChange2(val) {
			let that = this;
			that.page2 = val;
			that.getArticle();
		},
		initTime(value) {
			return moment(value * 1000).format('MM-DD-YYYY');
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	font-size: 14px;
	//块2
	.block_2{
		padding: 25px 20px 50px 20px;
		.news_box{
			.page_box{
				padding-top: 20px;
				text-align: center;
			}
			.list_box{
				padding-top: 3px;
				.list_el{
					display: inline-table;
					width: 100%;
					height: auto;
					position: relative;
					margin: 8px 0;
					padding: 12px 12px 12px 12px;
					background: #F6F6F6;
					.time{
						padding-top: 20px;
						color: #666666;
					}
					.txt{
						padding: 5px 0px 0 0px;
						font-size: 16px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 5;
						-webkit-box-orient: vertical;
						color: #666666;
					}
					.tit{
						padding: 12px 0px 0 0px;
						font-size: 24px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
					}
					.img_box{
						overflow: hidden;
						.img_el{
							width: 100%;
							height: 220px;
							object-fit: cover;
						}
					}
				}
			}
		}
		.tit_box{
			display: flex;
			align-items: center;
			padding-bottom: 5px;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//块1
	.block_1{
		padding: 50px 20px 25px 20px;
		background-color: #F6F6F6;
		.list_box{
			.page_box{
				padding-top: 20px;
				text-align: center;
			}
			.btn_box{
				margin-top: 20px;
				.btn_el{
					padding: 4px 12px 0 12px;
					font-size: 16px;
					border-radius: 6px;
				}
			}
			.block_2_el{
				display: inline-block;
				width: 100%;
				height: 300px;
				overflow: hidden;
				margin: 5px 0;
				text-align: center;
				position: relative;
				background-color: rgba(0, 0, 0, 0.4);
				img.img_bg{
					position: absolute;
					width: 100%;
					height: 100%;
					top: 0;
					left: 0;
					object-fit: cover;
				}
				.txt{
					padding: 2px 0;
					font-size: 18px;
					color: #ffffff;
					text-shadow: 2px 2px 2px #666666;
				}
				.tit{
					padding-bottom: 10px;
					font-size: 24px;
					color: #ffffff;
					text-shadow: 2px 2px 2px #666666;
				}
			}
			.block_1_el{
				display: inline-block;
				width: 100%;
				height: 300px;
				position: relative;
				margin: 5px 0;
				padding: 50px 40px 40px 40px;
				background-color: #F2F7FD;
				text-align: center;
				.txt{
					font-size: 18px;
					color: #000000;
				}
				.tit{
					padding-bottom: 10px;
					font-size: 24px;
					color: #0B318F;
				}
			}
		}
		.tit_box{
			display: flex;
			align-items: center;
			padding-bottom: 5px;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 0 20px;
			text-align: center;
			.txt{
				font-size: 18px;
				color: #ffffff;
			}
			.tit{
				font-size: 36px;
				color: #ffffff;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #E37542 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #E37542 !important;
}
>>> .page_box .el-pager li.active{
	color: #E37542 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>